<template>
	<div class="wrapper">
    <!-- 会员信息卡片 -->
    <el-card class="member-card" shadow="never" style="padding-bottom: 20px;;">
      <MemberInfo :member="detail.member" :detailInfo="detail" />
    </el-card>

    <!-- 标签页和内容区域 -->
    <el-card class="content-card" shadow="never" style="margin-top: 20px;">
      <el-tabs v-model="activeName" class="detail-tabs">
        <el-tab-pane name="1">
          <span slot="label">
            <i class="el-icon-document"></i>
            <span>订单资料</span>
          </span>
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label">
            <i class="el-icon-view"></i>
            <span>审核数据</span>
          </span>
        </el-tab-pane>
      </el-tabs>

      <div class="tab-content">
        <!-- 订单资料 -->
        <DetailBase
          ref="base"
          v-show="activeName == 1"
          :detail="detail"
          @refresh="handleDetailRefresh"
          @goJS="goJS"
        />

        <!-- 审核数据 -->
        <DetailJiShen
          ref="riskReview"
          v-show="activeName == 2"
        />
      </div>
    </el-card>
	</div>
</template>

<script>
import DetailBase from "./detail-base.vue";
import DetailJiShen from "./detail-jishen.vue";
import MemberInfo from "@/views/order/order-list/modules/member-info.vue";
import { getDetailAPI } from "@/views/order/order-list/api";

export default {
	name: "OrderDetail",
	components: {
    MemberInfo,
		DetailBase,
		DetailJiShen,
	},

	data() {
		return {
      detail: {},
			activeName: "1",
		};
	},

  activated() {
    this.getDetail();
  },

	methods: {
    async getDetail() {
      this.detail = await getDetailAPI(this.$route.params.id);
    },

    handleDetailRefresh() {
      this.getDetail();
    },

		goJS() {
			this.activeName = "2";
		},
	},
};
</script>

<style lang="scss" scoped>
.wrapper {
	width: 100%;
	min-width: 1150px;
	background: #f5f7fa;
	padding: 20px;
	height: calc(100vh - 84px);
	max-height: calc(100vh - 84px);
	display: flex;
	flex-direction: column;
	gap: 20px;
	overflow: hidden;
}

// 统一的卡片样式
.member-card,
.content-card {
	border-radius: 12px;
	border: none;
	background: #ffffff;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
	overflow: hidden;
	width: 100%;
	flex-shrink: 0;

	::v-deep .el-card__body {
		padding: 24px;
	}
}

.member-card {
	flex-shrink: 0;
}

// 内容卡片
.content-card {
	flex: 1;
	display: flex;
	flex-direction: column;
	min-height: 0;
	overflow: hidden;

	::v-deep .el-card__body {
		padding: 0;
		display: flex;
		flex-direction: column;
		flex: 1;
		min-height: 0;
		overflow: hidden;
	}

	.detail-tabs {
		flex-shrink: 0;
		
		::v-deep .el-tabs__header {
			margin: 0;
			background: #fafbfc;
			border-bottom: 1px solid #e4e7ed;
			padding: 0 24px;

			.el-tabs__nav-wrap {
				&::after {
					display: none;
				}
			}

			.el-tabs__nav {
				display: flex;
			}

			.el-tabs__item {
				font-size: 15px;
				font-weight: 500;
				color: #606266;
				padding: 0 24px;
				height: 50px;
				line-height: 50px;
				transition: all 0.3s ease;
				border-bottom: 2px solid transparent;
				margin-right: 8px;

				span {
					display: inline-flex;
					align-items: center;
					gap: 8px;
				}

				i {
					font-size: 16px;
					transition: all 0.3s ease;
				}

				&:hover {
					color: #409EFF;
					
					i {
						color: #409EFF;
					}
				}

				&.is-active {
					color: #409EFF;
					font-weight: 600;
					border-bottom-color: #409EFF;
					
					i {
						color: #409EFF;
					}
				}
			}

			.el-tabs__active-bar {
				display: none;
			}
		}
	}

	.tab-content {
		padding: 24px;
		flex: 1;
		min-height: 0;
		overflow-y: auto;
		overflow-x: hidden;
		
		&::-webkit-scrollbar {
			width: 6px;
		}

		&::-webkit-scrollbar-track {
			background: #f1f1f1;
			border-radius: 3px;
		}

		&::-webkit-scrollbar-thumb {
			background: #c1c1c1;
			border-radius: 3px;

			&:hover {
				background: #a8a8a8;
			}
		}
	}
}

.without-layout {
	.wrapper {
		height: 100% !important;
		overflow-y: hidden;
		display: flex;
		flex-direction: column;
		padding: 0;
		background: #f5f7fa;
		gap: 0;

		.member-card {
			margin: 0;
			border-radius: 0;
			box-shadow: none;
			padding: 20px 24px 0;
			flex-shrink: 0;
			
			::v-deep .el-card__body {
				padding: 0;
			}
		}

		.content-card {
			flex: 1;
			display: flex;
			flex-direction: column;
			border-radius: 0;
			box-shadow: none;
			margin: 0;
			min-height: 0;
			overflow: hidden;

			::v-deep .el-card__body {
				min-height: 0;
				overflow: hidden;
			}

			.tab-content {
				flex: 1;
				min-height: 0;
				overflow-y: auto;
				overflow-x: hidden;
			}
		}
	}
}

// 响应式设计
@media (max-width: 1400px) {
	.wrapper {
		padding: 16px;
		gap: 16px;
	}
}

@media (max-width: 768px) {
	.wrapper {
		padding: 12px;
		min-width: auto;
		gap: 12px;
	}

	.member-card,
	.content-card {
		border-radius: 8px;
		
		::v-deep .el-card__body {
			padding: 16px;
		}
	}

	.content-card {
		.detail-tabs ::v-deep .el-tabs__header {
			padding: 0 16px;

			.el-tabs__item {
				padding: 0 16px;
				font-size: 14px;

				i {
					display: none;
				}
			}
		}

		.tab-content {
			padding: 16px;
		}
	}
}
</style>
